'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _pullout = require('../../../pullout');

var _pullout2 = _interopRequireDefault(_pullout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Cta = function (_React$Component) {
  _inherits(Cta, _React$Component);

  function Cta() {
    _classCallCheck(this, Cta);

    return _possibleConstructorReturn(this, (Cta.__proto__ || Object.getPrototypeOf(Cta)).apply(this, arguments));
  }

  _createClass(Cta, [{
    key: 'render',
    value: function render() {
      var filteredProps = {
        content: {
          headline: {
            text: this.props.content.headline.text
          },
          cta: {
            text: this.props.content.cta.text,
            href: this.props.content.cta.href,
            fpti: 'ClsngCTA-PrmryCTA-' + this.props.content.cta.text,
            target: this.props.content.cta.target || '_self'
          }
        },
        config: {
          appBadge: false,
          textAlign: 'center',
          theme: this.props.config.theme,
          id: this.props.config.id
        }
      };

      if (this.props.content.image && this.props.content.image.src) {
        filteredProps.content.image = {
          src: this.props.content.image.src
        };
      }

      if (this.props.content.link) {
        filteredProps.content.link = {
          text: this.props.content.link.text,
          href: this.props.content.link.href,
          target: this.props.content.link.target,
          fpti: 'ClsngCTA-Link-' + this.props.content.link.text
        };
      }

      if (this.props.content.paragraph && this.props.content.paragraph.text) {
        filteredProps.content.paragraph = this.props.content.paragraph;
      }

      if (this.props.content.hatchText && this.props.content.hatchText.text) {
        filteredProps.content.hatchText = this.props.content.hatchText;
      }

      if (this.props.config.isLongHeadline) {
        filteredProps.config.isLongHeadline = this.props.config.isLongHeadline;
      }

      if (this.props.className) {
        filteredProps.className = this.props.className;
      }

      return _react2.default.createElement(_pullout2.default, filteredProps);
    }
  }]);

  return Cta;
}(_react2.default.Component);

exports.default = Cta;


Cta.propTypes = {
  config: _propTypes2.default.shape({
    theme: _propTypes2.default.oneOf(['theme-background-color-white', 'theme-background-color-light']).isRequired,
    isLongHeadline: _propTypes2.default.bool,
    id: _propTypes2.default.string
  }),
  content: _propTypes2.default.shape({
    image: _propTypes2.default.shape({
      src: _propTypes2.default.string.isRequired,
      alt: _propTypes2.default.string
    }),
    headline: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    paragraph: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }),
    cta: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired,
      href: _propTypes2.default.string.isRequired,
      target: _propTypes2.default.oneOf(['_self', '_blank'])
    }).isRequired,
    link: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired,
      href: _propTypes2.default.string.isRequired,
      target: _propTypes2.default.oneOf(['_self', '_blank'])
    }),
    hatchText: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    })
  }),
  className: _propTypes2.default.string
};

Cta.defaultProps = {
  config: {
    theme: 'theme-background-color-white',
    isLongHeadline: false,
    appBadge: false,
    textAlign: 'center',
    id: ''
  },
  content: {
    image: {
      src: 'https://www.paypalobjects.com/webstatic/en_CA/mktg/where-to-use-paypal/fashion/Adidas.png',
      alt: 'Description of image'
    },
    headline: {
      text: 'Fewer than 25 characters fit on one line in mobile.'
    },
    paragraph: {
      text: 'Fewer than 100 characters total to equal less than 3 lines in mobile.'
    },
    cta: {
      text: 'Fewer Than 29 Characters Max',
      href: '#',
      target: '_self'
    },
    link: {
      text: 'Less than 28 characters max',
      href: '#'
    },
    hatchText: {
      text: 'Fewer than 34 characters per line'
    }
  },
  className: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/pullout/cta/jsx/Cta.js
// module id = 1135
// module chunks = 4